<template>
  <el-row style="padding: 50px 50px 30px 50px;" v-loading.body="fetchLoding">
    <!-- 基本信息 -->
    <el-form :model="agentForm" :rules="rules" label-width="120px" ref="ruleForm">
      <div>
        <p v-if="!this.isEdit" style="color: red; font-size: 14px;">{{ generateCustomizeString('agentNotice') }}</p>
        <h4 v-if="!this.isEdit">{{generateCustomizeString('newAgent')}}</h4>
        <div v-else>
          <el-tag>{{ generateCustomizeString('mobileURL') }}
            <a
              :href="mobileUrl + agentForm.shop_domain_prefix + '/home'"
              target="_blank"
              style="text-decoration:underline;"
            >{{ mobileUrl + agentForm.shop_domain_prefix + '/home' }}</a>
          </el-tag>
          <h4>{{generateCustomizeString('editAgent')}}</h4>
        </div>
        <p style="padding-left: 120px; font-size: 14px; color: red;">{{ generateCustomizeString('compulsory') }}</p>
        <el-form-item
          :label="generateCustomizeString('agentUsername')"
          prop="shop_admin_email"
          v-if="!this.isEdit"
        >
          <el-input
            v-model="agentForm.shop_admin_email"
            :placeholder="generateCustomizeString('agentUsernameRequirement')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('agentUsername')" prop="shop_admin_email" v-else>
          <el-input
            v-model="agentForm.admin.email"
            :placeholder="generateCustomizeString('agentUsername')"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="generateCustomizeString('initPassword')"
          prop="shop_admin_password"
          v-if="!this.isEdit"
        >
          <el-input
            v-model="agentForm.shop_admin_password"
            :placeholder="generateCustomizeString('initPassword')"
            show-password="true"
          ></el-input>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('password')" v-else>
          <el-input placeholder="**********" style="width: 30%;" disabled></el-input>
          <el-button @click="editPassword()" style="width: 10%;">{{ generateCustomizeString('editPassword') }}</el-button>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('shopName')" prop="display_shop_name">
          <el-input
            v-model="agentForm.display_shop_name"
            :placeholder="generateCustomizeString('shopName')"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          :label="generateCustomizeString('domainPrefix')"
          prop="shop_domain_prefix"
          v-if="!this.isEdit"
        >
          <el-input
            v-model="agentForm.shop_domain_prefix"
            :placeholder="generateCustomizeString('domainPrefixRequirement')"
            onkeyup="value=value.replace(/[\W]/g,'') "
          >
            <template slot="append">.nzmai.com.cn</template>
          </el-input>
        </el-form-item> -->
        <el-form-item :label="generateCustomizeString('agentLevel')" prop="agent_level">
          <el-select
            v-model="agentForm.agent_level"
            :placeholder="generateCustomizeString('agentLevel')"
          >
            <el-option
              v-for="item in levels"
              :key="item.level"
              :label="item.name"
              :value="item.level"
            ></el-option>
          </el-select>
          <span style="color: red;">{{ generateCustomizeString('agentLevel') }}</span>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('shopLogo')">
          <el-select
            v-model="agentForm.shop_logo_qiniu_res_key"
            placeholder="请选择Logo"
            style="width: 260px; margin-bottom: 10px;"
            v-if="!agentForm.shop_logo_url"
            clearable
          >
            <el-option
              v-for="logo in logos"
              :key="logo.key"
              :label="logo.name"
              :value="logo.key"
              style="height: 70px; padding: 5px 20px; display: flex; align-items: center;"
            >
              <img class="avatar" :src="logo.src" style="height:60px">
              <span style="height: 35px; margin-left: 20px;">{{ logo.name }}</span>
            </el-option>
          </el-select>
          <span v-if="!agentForm.shop_logo_url" style="margin-left: 10px; color: #606266;">{{generateCustomizeString('selectOrUploadLogo')}}</span>
          <el-upload
            action="https://upload-z2.qiniup.com"
            :limit="2"
            :drag="true"
            :file-list="fileList"
            :on-change="handleChange"
            :http-request="compressImg"
            :on-success="handleAvatarSuccess"
            :on-error="handleError"
            :before-upload="beforeAvatarUpload"
            :data="qiniuData"
            v-loading="imgLoading"
            :element-loading-text="generateCustomizeString('UploadingImg')"
          >
            <img v-if="agentForm.shop_logo_url" :src="displayLogoUrl" class="avatar">
            <div>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                {{generateCustomizeString('dragFiles')}}
                <em>{{generateCustomizeString('uploadFiles')}}</em>
              </div>
            </div>
            <div class="el-upload__tip" slot="tip">{{generateCustomizeString('fileLimit')}}</div>
          </el-upload>
        </el-form-item>
        <el-form-item
          :label="generateCustomizeString('contactPerson')"
          prop="merchant_name"
          v-if="!isEdit"
        >
          <el-input
            v-model="agentForm.merchant_name"
            :placeholder="generateCustomizeString('contactPerson')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="generateCustomizeString('contactPhone')"
          prop="merchant_contact_phone"
        >
          <el-input
            v-model="agentForm.merchant_contact_phone"
            :placeholder="generateCustomizeString('contactPhone')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="generateCustomizeString('contactEmail')"
          prop="merchant_contact_email"
        >
          <el-input
            v-model="agentForm.merchant_contact_email"
            :placeholder="generateCustomizeString('contactEmail')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('contactAddress')" prop="merchant_address">
          <el-input
            v-model="agentForm.merchant_address"
            :placeholder="generateCustomizeString('contactAddress')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('contactWechat')" prop="wechat_id">
          <el-input
            v-model="agentForm.wechat_id"
            :placeholder="generateCustomizeString('contactWechat')"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item :label="generateCustomizeString('agreePolicy')" v-if="!isEdit">
          <el-switch v-model="agreePolicy"></el-switch>
          <el-button type="text" @click="policyVisible = true">{{ generateCustomizeString('distributorAgreement') }}</el-button>
        </el-form-item> -->

        <el-dialog
          title="分销平台使用协议"
          :visible.sync="policyVisible"
          width="30%"
          :before-close="handleClose">
          <span>{{ generateCustomizeString('agentMsg1') }}</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="policyVisible = false">{{ generateCustomizeString('cancel')}}</el-button>
            <el-button type="primary" @click="policyVisible = false">{{ generateCustomizeString('confirm') }}</el-button>
          </span>
        </el-dialog>

        <el-dialog
          :title="generateCustomizeString('changePassword')"
          :visible.sync="changePasswordDialogVisible"
          width="30%"
          :append-to-body="true"
        >
          <el-form ref="form" :model="passwordForm" class="detailForm" label-width="27%">
            <div style="margin: 0 10px;">
              <el-form-item :label="generateCustomizeString('password')" prop="password">
                <el-input v-model="passwordForm.password" style="width: 100%;"></el-input>
              </el-form-item>
              <el-form-item :label="generateCustomizeString('confirmPassword')" prop="password">
                <el-input v-model="passwordForm.confirm_password" style="width: 100%;"></el-input>
              </el-form-item>
              <el-form-item style="margin-top: 40px;">
                <div>
                  <el-button @click="changePasswordDialogVisible = false" style="width: 80px;">{{ generateCustomizeString('cancel')}}</el-button>
                  <el-button
                    type="primary"
                    @click="confirmChangePassword()"
                    style="width: 80px; margin-left: 20px;"
                  >{{ generateCustomizeString('confirm')}}</el-button>
                </div>
              </el-form-item>
            </div>
          </el-form>
        </el-dialog>
      </div>

      <el-col>
        <el-form-item style="margin-left: -40px; margin-top: 20px;">
          <el-button
            v-if="isEdit"
            type="primary"
            @click="updateAgentInfo"
            plain
            class="btn"
          >{{generateCustomizeString('update')}}</el-button>
          <el-button
            v-else
            type="primary"
            @click="createAgent"
            plain
            class="btn"
          >{{generateCustomizeString('create')}}</el-button>
        </el-form-item>
      </el-col>
    </el-form>
  </el-row>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import compressor from '@/utils/compressor'
import axios from 'axios'
// import { resolve } from 'q';

export default {
  name: 'AgentDetail',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mobileUrl: process.env.VUE_APP_MOBILE_URL,
      agentForm: {
        shop_logo_url: '',
        shop_admin_email: '',
        shop_admin_password: '',
        display_shop_name: '',
        shop_domain_prefix: '',
        agent_level: '',
        shop_logo_qiniu_res_key: '',
        merchant_name: '',
        merchant_contact_phone: '',
        merchant_contact_email: '',
        merchant_address: '',
        wechat_id: '',
        admin: {
          email: '',
          username: ''
        }
      },
      changePasswordDialogVisible: false,
      levels: [],
      agreePolicy: false,
      currentDate: new Date(),
      qiniuData: {
        token: ''
      },
      agentId: 0,
      view: {},
      passwordForm: {
        password: '',
        confirm_password: ''
      },
      fileList: [],
      imgLoading: false,
      logos: [
        {
          name: 'Logo 1',
          key: 'FhLxDCp4fdJurFR3RUpunY3uDr0s',
          src: 'https://img.nzmai.com.cn/FhLxDCp4fdJurFR3RUpunY3uDr0s?imageView2/0/w/100/h/100/q/75|imageslim'
        },
        {
          name: 'Logo 2',
          key: 'FsHj__rdLITKsTyhdmdrWF2G04ke',
          src: 'https://img.nzmai.com.cn/FsHj__rdLITKsTyhdmdrWF2G04ke?imageView2/0/w/100/h/100/q/75|imageslim'
        },
        {
          name: 'Logo 3',
          key: 'FoeXAno3tPcNnRy617kMfhbA-Z7H',
          src: 'https://img.nzmai.com.cn/FoeXAno3tPcNnRy617kMfhbA-Z7H?imageView2/0/w/100/h/100/q/75|imageslim'
        },
        {
          name: 'Logo 4',
          key: 'FsRhq0JL5sh4nJQeChFqNXqYP9Gn',
          src: 'https://img.nzmai.com.cn/FsRhq0JL5sh4nJQeChFqNXqYP9Gn?imageView2/0/w/100/h/100/q/75|imageslim'
        },
        {
          name: 'Logo 5',
          key: 'Fh7JcWRxumSvircC5Tvzh0xLXACa',
          src: 'https://img.nzmai.com.cn/Fh7JcWRxumSvircC5Tvzh0xLXACa?imageView2/0/w/100/h/100/q/75|imageslim'
        },
        {
          name: 'Logo 6',
          key: 'FvoqoStIk9XqMagRWUYNRGNpGl9F',
          src: 'https://img.nzmai.com.cn/FvoqoStIk9XqMagRWUYNRGNpGl9F?imageView2/0/w/100/h/100/q/75|imageslim'
        }
      ],
      rules: {
        shop_admin_email: [
          {
            required: true,
            min: 6,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        shop_admin_password: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        display_shop_name: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        // shop_domain_prefix: [
        //   {
        //     required: true,
        //     message: '请输入域名前缀(最少4位英文字母)',
        //     trigger: 'blur'
        //   }
        // ],
        agent_level: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        merchant_name: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        merchant_contact_phone: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        merchant_contact_email: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        merchant_address: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        wechat_id: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ]
      },
      fetchLoding: false,
      policyVisible: false
    }
  },
  computed: {
    displayLogoUrl() {
      return (
        this.agentForm.shop_logo_url +
        '?imageView2/0/w/360/h/180/q/75|imageslim'
      )
    }
  },
  methods: {
    generateCustomizeString,
    fetchUploadToken() {
      request({
        url: '/upload-token',
        method: 'get'
      })
        .then(res => {
          this.qiniuData.token = res.data['token']
          console.log(this.qiniuData)
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleError(res) {
      console.log(res)
    },
    handleAvatarSuccess(res, file) {
      // 上传成功后在图片框显示图片
      // 更改了key
      console.log(res)
      this.agentForm.shop_logo_qiniu_res_key = res.key
      this.agentForm.shop_logo_url = 'https://img.nzmai.com.cn/' + res.key
      console.log(res)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 4
      if (!isJPG && !isPNG) {
        this.$message.error(this.generateCustomizeString('jpgpngonly'))
      }
      if (!isLt2M) {
        this.$message.error(this.generateCustomizeString('lessThan2MB'))
      }
      return (isJPG || isPNG) && isLt2M
    },
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
    },
    compressImg(item) {
      this.imgLoading = true
      compressor.image(item.file)
        .then(file => {
          console.log(file)
          const formData = new FormData()
          formData.append('token', this.qiniuData.token)
          formData.append('file', file)

          const axiosInstance = axios.create({})
          axiosInstance({
            url: 'https://upload-z2.qiniup.com',
            method: 'POST',
            data: formData
          }).then(response => {
            console.log(response.data.key)
            this.agentForm.shop_logo_qiniu_res_key = response.data.key
            this.agentForm.shop_logo_url = 'https://img.nzmai.com.cn/' + response.data.key
            this.imgLoading = false
          }).catch(error => {
            console.log(error)
            this.imgLoading = false
          })
        })
    },
    editPassword() {
      this.changePasswordDialogVisible = true
    },
    fetchLevels() {
      request({
        url: 'discount/level/list',
        method: 'get'
      })
        .then(response => {
          this.levels = response.data
          console.log(this.levels)
        })
        .catch(error => {
          console.warn(error)
        })
    },
    updateAgentInfo() {
      this.fetchLoding = true
      request({
        url: 'agent/' + this.$route.params.agentId,
        method: 'patch',
        data: {
          display_shop_name: this.agentForm.display_shop_name,
          shop_logo_qiniu_res_key: this.agentForm.shop_logo_qiniu_res_key,
          // shop_domain_prefix: this.agentForm.shop_domain_prefix,
          merchant_address: this.agentForm.merchant_address,
          merchant_contact_phone: this.agentForm.merchant_contact_phone,
          merchant_contact_email: this.agentForm.merchant_contact_email,
          wechat_id: this.agentForm.wechat_id,
          agent_level: this.agentForm.agent_level,
          admin: {
            email: this.agentForm.admin.email
          }
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('updateSuccessfully'),
              type: 'success'
            })
            this.fetchLoding = false
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    fetchAgentInfo() {
      return new Promise((resolve, reject) => {
        this.fetchLoding = true
        request({
          url: 'agent/' + this.agentId,
          method: 'get'
        })
          .then(res => {
            if (res.status === 0) {
              this.agentForm = res.data
              console.log(this.agentForm)
              resolve()
            }
            this.fetchLoding = false
          })
          .catch(error => {
            console.log(error)
            reject()
          })
      })
    },
    createAgent() {
      this.agentForm.shop_admin_email = this.agentForm.shop_admin_email.replace(/[\W]/g, '')
      if (this.agentForm.shop_admin_email.length < 6) {
        this.$message({
          message: this.generateCustomizeString('accountMoreThan6Characters'),
          type: 'warning'
        })
        return
      }
      // if (this.agentForm.shop_domain_prefix.length < 4) {
      //   this.$message({
      //     message: '域名前缀必须大于4位英文字母',
      //     type: 'warning'
      //   })
      //   return
      // }
      // if (!this.agreePolicy) {
      //   this.$message({
      //     message: '您未同意三方协议书',
      //     type: 'warning'
      //   })
      //   return
      // }
      if (this.agentForm.shop_logo_qiniu_res_key.length === 0) {
        this.$message({
          message: this.generateCustomizeString('pleaseEnter'),
          type: 'warning'
        })
        return
      }
      var data = {
        shop_admin_email: this.agentForm.shop_admin_email,
        shop_admin_password: this.agentForm.shop_admin_password,
        display_shop_name: this.agentForm.display_shop_name,
        // shop_domain_prefix: this.agentForm.shop_domain_prefix,
        shop_logo_qiniu_res_key: this.agentForm.shop_logo_qiniu_res_key,
        merchant_name: this.agentForm.merchant_name,
        merchant_address: this.agentForm.merchant_address,
        merchant_contact_phone: this.agentForm.merchant_contact_phone,
        merchant_contact_email: this.agentForm.merchant_contact_email,
        agent_level: this.agentForm.agent_level,
        wechat_id: this.agentForm.wechat_id
      }
      request({
        url: '/agent',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('createdSuccessfully'),
              type: 'success'
            })
            this.$store.dispatch('delVisitedViews', this.view).then(() => {
              this.$router.push({ name: 'AgentList' })
            })
          } else {
            this.$message.error(res.error)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('createFailed'))
        })
    },
    confirmChangePassword() {
      if (this.passwordForm.password && this.passwordForm.confirm_password) {
        if (this.passwordForm.password === this.passwordForm.confirm_password) {
          request({
            url: 'agent/' + this.agentForm.id,
            method: 'patch',
            data: {
              password: this.passwordForm.password,
              confirm_password: this.passwordForm.confirm_password
            }
          })
            .then(res => {
              if (res.status === 0) {
                this.$message({
                  message: this.generateCustomizeString('updateSuccessfully'),
                  type: 'success'
                })
                this.fetchAgentInfo()
              }
            })
            .catch(error => {
              console.warn(error)
            })
            .finally(() => {
              this.passwordForm.password = ''
              this.passwordForm.confirm_password = ''
              this.changePasswordDialogVisible = false
            })
        } else {
          this.$message.error(this.generateCustomizeString('passwordUnmatch'))
        }
      } else {
        this.$message.error(this.generateCustomizeString('passwordCanNotBeEmpty'))
      }
    }
  },
  created() {
    this.agentId = this.$route.params.agentId
    this.fetchUploadToken()
    this.fetchLevels()
    if (this.isEdit) {
      this.fetchAgentInfo()
    }
    for (let i = 0; i < this.$store.state.tagsView.visitedViews.length; i++) {
      if (this.$store.state.tagsView.visitedViews[i].name === 'CreateAgent') {
        this.view = this.$store.state.tagsView.visitedViews[i]
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #ffffff;
}
.bg-purple-light {
  background: #e5e9f2;
}

.content-label {
  padding: 0px 0px 0px 20px;
}

.el-select {
  width: 130px;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}
.btn {
  width: 150px;
  height: 50px;
  font-size: 16px;
}
</style>
<style type="text/css">
</style>
